import { useRouter } from "next/router";

const useIsDashboard = (): boolean => {
  const router = useRouter();
  return router.pathname.includes("/dashboard");
};

export default useIsDashboard;
